module.exports = __webpack_public_path__ + "img/Z86Q_13.dc28ada6.jpg";